import {useMutation} from '@apollo/react-hooks';

import type {
    CreateSalesDocument as CreateSalesDocumentMutation,
    CreateSalesDocumentVariables,
    SalesDocumentCreateInput,
} from 'nutshell-graphql-types';

import CREATE_SALES_DOCUMENT from '../mutations/create-sales-document.graphql';

export const useCreateSalesDocument = (): {
    createSalesDocument: (input: SalesDocumentCreateInput) => Promise<any>;
} => {
    const [createSalesDocument] = useMutation<
        CreateSalesDocumentMutation,
        CreateSalesDocumentVariables
    >(CREATE_SALES_DOCUMENT);

    return {
        createSalesDocument: (input: SalesDocumentCreateInput) => {
            return createSalesDocument({
                variables: {
                    input: {
                        ...input,
                    },
                },
            });
        },
    };
};
